export const education = [
  {
    degree: "Master of Science — Computer Science",
    school: "University of Colorado Denver, USA",
    notes: "Big Data Systems · Data Science ·  Machine Learning · Deep Learning · Cyber Security"
  },
  {
    degree: "Bachelor of Technology — Computer Science",
    school: "Jawaharlal Nehru Technological University, Hyderabad",
    notes: "Algorithms · Data Structures · Software Engineering · Solar Sustainability App (Award-Winning)"
  }
]
